import React from "react";
import NumberFormat from "react-number-format";

function input(props) {
  let input = null;

  switch (props.type) {
    case "select":
      input = (
        <div className="main_select">
          <select
            name="cancelReason"
            onChange={props.onChange}
            value={props.inputProps.value}
          >
            {props.inputProps.options.map((option, i) => (
              <option key={i} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      );
      break;
    case "textarea":
      input = <textarea {...props.inputProps} onChange={props.onChange} />;
      break;
    default:
      input = (
        <input
          className="input_text"
          {...props.inputProps}
          onChange={props.onChange}
          autoFocus={props.autoFocus}
          autoComplete="off"
        />
      );
      break;
  }

  return (
    <React.Fragment>
      {props.inputKey === "phone" ? (
        <NumberFormat
          format="### ### ####"
          className="input_text"
          value={props.inputProps.value}
          onChange={props.onChange}
          placeholder={props.inputProps.placeholder}
        />
      ) : (
        input
      )}
    </React.Fragment>
  );
}

export default input;
